import React, { useState, useEffect, useRef } from "react";
import { useSnackbar } from "notistack";
// import { FaTrash } from "react-icons/fa";
// import { MdEditSquare } from "react-icons/md";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import AdminLoader from "../../components/common/loader/AdminLoader";
import { useDispatch, useSelector } from "react-redux";
import {

  createOrUpdateGroup,
  deleteGroup,
  fetchGroups,
  updateGroup
} from '../../store/slices/groupSlice';
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchServiceTypes } from "../../store/slices/serviceTypesSlice";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { SquarePen, Trash2, Plus } from "lucide-react";
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';


const AddGroup = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Add Group"));
  }, [dispatch]);

  const [isLoading, SetisLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [showLogout, setshowlogout] = useState(false);
  const popupRef = useRef(null);
  // const [serviceSearchTerm, setServiceSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false);
    }
  };

  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);
  const [sortOrder, setSortOrder] = useState(null); // 'az' for A-Z, 'za' for Z-A
  const [newGroupName, setNewGroupName] = useState("");
  const [editingGroupNameId, setEditingGroupNameId] = useState(null);
  const [GroupNames, setGroupNames] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [groupToDelete, setGroupToDelete] = useState(null);
  // const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  // const [TypeServices, setSelectedServicess] = useState([]);
  // const [serviceTypes, setServiceTypes] = useState([]);
  // const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
  const [TypeService, setSelectedServices] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const { group, lastFetch } = useSelector((state) => state.group);
  const shouldFetch = !lastFetch || Date.now() - lastFetch > 300000;

  console.log("Gsdsdg", TypeService)

  const dropdownsRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
      if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
        // Also check if the click was on the ellipsis icon itself
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');

        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchGroups());
    }
    dispatch(fetchServiceTypes());
  }, [dispatch, shouldFetch]);

  useEffect(() => {
    setGroupNames(group);
    // setServiceTypes(serviceTypesRedux);
  }, [group]);

  const Submit = async (e) => {
    e.preventDefault();
    if (!newGroupName) {
      enqueueSnackbar("Please fill all the required fields!", { variant: "error" });
      return;
    }
    if (!TypeService || TypeService.length === 0) {
      enqueueSnackbar("At least one Service Type is required.", { variant: "error" });
      return;
    }
    SetisLoading(true);
    try {
      if (!editingGroupNameId) {
        await dispatch(
          createOrUpdateGroup({ newGroupName, servicetype: TypeService })
        ).unwrap();
        enqueueSnackbar("Group and Service Type added Successfully.", {
          variant: "success"
        });
      } else {
        await dispatch(
          updateGroup({ id: editingGroupNameId, newGroupName, servicetype: TypeService })
        ).unwrap();
        enqueueSnackbar("Group and Service Type updated Successfully.", {
          variant: "success"
        });
      }
      setEditingGroupNameId("");
      setNewGroupName("");
      setSelectedServices([]);
      setInputValue("")
    } catch (error) {
      const errorMessage = error.message || error.response?.data?.message || error.response?.data?.error || "Something went wrong!";
      // Replace backend error message with custom message if it's about servicetype
      if (errorMessage.toLowerCase().includes("servicetype") || errorMessage.toLowerCase().includes("service type")) {
        enqueueSnackbar("At least one Service Type is required.", {
          variant: "error"
        });
      } else {
        enqueueSnackbar(errorMessage, {
          variant: "error"
        });
      }
    } finally {
      SetisLoading(false);
    }
  };

  // const Cancel = (e) => {
  //   e.preventDefault();
  //   setNewGroupName("");
  //   setEditingGroupNameId(false);
  //   setSelectedServices([]);
  //   setServiceSearchTerm("")
  // };

  // const editGroupName = (id, GroupName) => {
  //   setEditingGroupNameId(id);
  //   setNewGroupName(GroupName?.newGroupName);
  //   setSelectedServices(GroupName?.servicetype || []);
  // };

  const deleteGroupName = async (id) => {
    try {
      const resultAction = await dispatch(deleteGroup(id));

      if (deleteGroup.fulfilled.match(resultAction)) {
        enqueueSnackbar("Group Name Deleted Successfully!", {
          variant: "success",
        });
        setGroupNames(GroupNames.filter((group) => group.id !== id));
      } else {
        enqueueSnackbar("Failed to delete Group Name", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Connection Error!", { variant: "error" });
    }
  };

  const openDeleteModal = (id) => {
    setGroupToDelete(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setGroupToDelete(null);
  };

  const confirmDelete = async () => {
    if (groupToDelete) {
      await deleteGroupName(groupToDelete);
    }
    closeDeleteModal();
  };

  // const dropdownRefService = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       dropdownRefService.current &&
  //       !dropdownRefService.current.contains(event.target)
  //     ) {
  //       setShowServiceDropdown(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  // const handleServiceChange = (service) => {
  //   setSelectedServices((prevSelected) => {
  //     if (prevSelected.includes(service)) {
  //       return prevSelected.filter((s) => s !== service);
  //     } else {
  //       return [...prevSelected, service];
  //     }
  //   });
  //   setServiceSearchTerm("");
  // };



  // Handle input changes
  const handleInputChange = (e) => {

    const value = e.target.value.replace(/[^a-zA-Z0-9 ,]/g, "");

    // const value = e.target.value;
    setInputValue(value);
  };

  // Process the input when user finishes typing
  const processInput = () => {
    if (!inputValue.trim()) return;

    // Split by commas, trim whitespace, filter out empty strings
    const newServices = inputValue
      .split(",")
      .map(service => service.trim())
      .filter(service => service.length > 0);

    // Remove duplicates
    const uniqueServices = [...new Set(newServices)];

    setSelectedServices(uniqueServices);
    // Keep the processed value in input for editing
    setInputValue(uniqueServices.join(", "));
  };

  // Handle key events
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      processInput();
    }

    // Handle backspace to delete last item
    if (e.key === 'Backspace' && inputValue === "" && TypeService.length > 0) {
      const newServices = [...TypeService];
      newServices.pop();
      setSelectedServices(newServices);
      setInputValue(newServices.join(", "));
    }
  };

  // Handle click on input to show current array as editable text
  const handleInputClick = () => {
    // Set input value to current TypeService array joined by commas
    setInputValue(TypeService.join(", "));
  };

  // Handle blur - save changes when user leaves the input
  // const handleBlur = () => {
  //   processInput();
  // };

  // Clear input when starting to edit a group
  const editGroupName = (id, GroupName) => {
    setEditingGroupNameId(id);
    setNewGroupName(GroupName?.newGroupName);
    setSelectedServices(GroupName?.servicetype || []);
    // Also update the input value when editing
    setInputValue(GroupName?.servicetype?.join(", ") || "");
  };

  // Clear everything when canceling
  const Cancel = (e) => {
    e.preventDefault();
    setNewGroupName("");
    setEditingGroupNameId(false);
    setSelectedServices([]);
    setInputValue(""); // Clear input value too
  };

  // const handleServiceAdd = async (service) => {
  //   try {
  //     await dispatch(addServiceType(service)).unwrap();
  //   } catch (error) {
  //     console.error("Error:", error);
  //     enqueueSnackbar(error?.message || "Failed to add Service Type", {
  //       variant: "error",
  //     });
  //   } finally {
  //     SetisLoading(false);
  //   }
  // };

  // const handleKeyDown = (e) => {
  //   if (e.key === 'Enter' && serviceSearchTerm.trim()) {
  //     // Check if the term is not already in the list
  //     if (!serviceTypes.some(st => st.ServiceType.toLowerCase() === serviceSearchTerm.toLowerCase())) {
  //       handleServiceChange(serviceSearchTerm);
  //       handleServiceAdd(serviceSearchTerm)
  //     }

  //     setServiceSearchTerm("");
  //   }
  // };

  const handleSearchInputChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");

    setSearchQuery(value);

  };




  const sortAlphabetically = (field, order) => {
    setSortOrder(order);
  };
  const filteredGroupNames = GroupNames
    .filter(group =>
      group.newGroupName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (group.servicetype &&
        group.servicetype.some(service =>
          service.toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    )
    .sort((a, b) => {
      if (sortOrder === 'az') {
        return a.newGroupName.localeCompare(b.newGroupName);
      } else if (sortOrder === 'za') {
        return b.newGroupName.localeCompare(a.newGroupName);
      }
      return 0; // no sorting
    });



  useEffect(() => {
    const handleScroll = () => {
      setOpenDropdownId(null);
    };

    // Get the table container element
    const tableContainer = document.querySelector('.maintable'); // Escape the class name

    // Add scroll listener to window
    window.addEventListener("scroll", handleScroll);

    // Add scroll listener to table container if it exists
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Clean up both listeners
      window.removeEventListener("scroll", handleScroll);

      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <div className=" bg-[#f3f8f8] pb-6 h-full">
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={closeDeleteModal}
          onConfirm={confirmDelete}
        />

        <div className="relative">
          {isLoading && (
            <AdminLoader isLoading={isLoading} />
          )}

          <div className="flex justify-center align-middle items-center">
            <div className="flex flex-col w-[80%] pt-2 gap-4">
              {/* Page Title */}
              <div className="flex items-center gap-2">
                <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                <h1 className="text-2xl font-semibold">Add New Group</h1>
              </div>

              <div className="flex gap-2">
              <div className="w-[40%] bg-white rounded-md h-fit ">
                <div className="flex px-3 py-4 gap-2 align-middle items-center border-b">
                  <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                  <h2 className="font-semibold text-xl">
                    Group Information
                  </h2>
                </div>

                <div className="mainform px-3 py-2 flex flex-col gap-3">
                  <div>
                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                      <PeopleOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Group Name <span className="text-red-700 text-xs">*</span>
                    </div>
                    <div>
                      <input
                        className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                        type="text"
                        maxLength={30}
                        placeholder="e.g. Rail Grinding Services."
                        value={newGroupName}
                        onChange={(e) => {
                          const newValue = e.target.value
                            .replace(/[^a-zA-Z0-9\s-]/g, "")
                            .slice(0, 30);
                          setNewGroupName(newValue);
                        }}

                      />
                    </div>
                  </div>
                  <div>
                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                      <LocalOfferOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Service Type
                    </div>
                    <div className="relative">
                      <input
                        className="w-full rounded-md text-xs p-2 border bg-[#fcfcfc] border-[#e5e7eb] outline-none"
                        type="text"
                        id="service"
                        placeholder=""
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onBlur={processInput}
                        onClick={handleInputClick}
                        onFocus={handleInputClick}
                      />
                    </div>
                    <div className="p-1">
                      <p className="text-xs text-[#606060]">Seperate Service types with comma (Mandatory).</p>
                    </div>
                  </div>

                  <div className="flex gap-2 text-xs">
                    <button
                      onClick={Submit}
                      className=" p-1 flex align-middle items-center gap-2 px-4 bg-[#0f61e6] hover:bg-blue-400 overflow-hidden text-white rounded-lg"
                    >
                      <Plus size={16} />
                      {editingGroupNameId ? "Update Group" : "Create Group"}
                    </button>
                    <button
                      onClick={Cancel}
                      className=" py-2 px-3 border border-[#e5e7eb] bg-white overflow-hidden rounded-lg"
                    >
                      Reset
                    </button>
                  </div>

                </div>
              </div>
              {/* <div className="  p-4 h-fit w-1/2 bg-white border border-gray-200  shadow-lg rounded-md">
                
                <div className="flex gap-2">
                  <div className="w-[50%] ">
                    <label className='block' htmlFor="Group">Group</label>
                    <input
                        className=" w-full  p-2 overflow-hidden outline-none border border-gray-400 shadow-md rounded-md"
                      type="text"
                      placeholder="Enter Group Name"
                      value={newGroupName}
                      onChange={(e) => {
                        const newValue = e.target.value
                          .replace(/[^a-zA-Z0-9\s-]/g, "")
                          .slice(0, 30);
                        setNewGroupName(newValue);
                      }}
                    />
                  </div>

                  <div className="w-[50%] ">
                    <label className='block' htmlFor="service">Service Types</label>

                    <div className="relative">
                      <input
                          className="w-full rounded-md p-2 border border-gray-400 shadow-md outline-none"
                        type="text"
                        id="service"
                        placeholder="Enter services"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onBlur={processInput}
                        onClick={handleInputClick}
                        onFocus={handleInputClick}
                      />
                    </div>
                  </div>
                  
                </div>

                <div className="mx-4 mt-8">
                  <button
                    onClick={Submit}
                    className="mr-2 py-1 px-5 bg-[#e32278] hover:bg-[#e12298] overflow-hidden shadow-md text-white rounded-md"
                  >
                    {editingGroupNameId ? "Update" : "Submit"}
                  </button>
                  <button
                    onClick={Cancel}
                    className="ml-2 py-1 px-5 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-md"
                  >
                    Cancel
                  </button>
                </div>
              </div> */}


              <div className=" w-[60%] p-4 bg-white rounded-md">
                <div className="flex justify-between align-middle items-center py-2">
                  <div className=" flex items-center gap-3 shrink-0">
                    <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                    <h1 className="text-lg font-semibold text-gray-900">
                      Groups Directory
                    </h1>
                  </div>

                  <div className="flex gap-2 p-2 align-middle items-center border border-[#e5e7eb] rounded-lg">
                    <MdSearch className=" w-5 h-5 text-gray-500" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      placeholder="Search"
                      className="w-full outline-none text-sm text-gray-900 placeholder-gray-500" />
                  </div>
                </div>
                <hr />
                <hr />
                <br />
                <div className="maintable min-h-[10rem] max-h-[60vh] overflow-auto">
                  <table className="min-w-full divide-y divide-gray-200 border text-xs">
                    <thead className="bg-[#e8e8e8] sticky top-0 z-50 font-semibold">
                      <tr>
                        <th className="border p-2 text-center tracking-wider  font-medium capitalize">
                          Sr. No
                        </th>
                        <th className="p-2 flex justify-between align-middle items-center text-center  font-medium capitalize">
                          Group Name
                          <div className="flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() => sortAlphabetically("newGroupName", "az")}
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() => sortAlphabetically("newGroupName", "za")}
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </th>
                        <th className="border p-2 text-start tracking-wider  font-medium capitalize">
                          Service Types
                        </th>
                        <th className="border p-2 text-center tracking-wider  font-medium capitalize">
                          Actions
                        </th>
                        {/* <th className="border p-2 text-center tracking-wider text-sm font-medium capitalize">
                        Delete
                      </th> */}
                      </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200 ">
                      {filteredGroupNames.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center text-red-500 py-4">No result found</td>
                        </tr>
                      ) : (
                        filteredGroupNames.map((GroupName, index) => (
                          <tr className="border border-gray-400" key={index}>
                            <td className="px-2 border-b text-center py-2 ">{index + 1}</td>
                            <td className="px-2 text-start py-2 border-b">
                              {GroupName.newGroupName}
                            </td>
                            <td className="px-2 text-start py-2 border-b">
                              <div className="flex flex-wrap gap-2">
                                {Array.isArray(GroupName.servicetype) && GroupName.servicetype.length > 0 ? (
                                  GroupName.servicetype.map((type, index) => (
                                    <span
                                      key={index}
                                      className="px-3 py-1 text-xs rounded-full 
                     bg-blue-100 text-blue-700 
                     border border-blue-300"
                                    >
                                      {type}
                                    </span>
                                  ))
                                ) : (
                                  <span className="px-3 py-1 text-xs rounded-full bg-blue-100 text-blue-700 border border-blue-300">NA</span>
                                )}
                              </div>
                            </td>

                            <td
                              className="px-2 border-b text-center py-2"
                            >
                              <div className="flex justify-center items-center gap-3">
                                <div
                                  onClick={() => editGroupName(GroupName.id, GroupName)}
                                  className="cursor-pointer hover:opacity-70"
                                  title="Edit"
                                >
                                  <SquarePen size={18} className="text-blue-500" />
                                </div>
                                <div
                                  onClick={() => openDeleteModal(GroupName.id)}
                                  className="cursor-pointer hover:opacity-70"
                                  title="Delete"
                                >
                                  <Trash2 size={18} className="text-blue-500" />
                                </div>
                              </div>
                            </td>


                            {/* <td
                            onClick={() => editGroupName(GroupName.id, GroupName)}
                            className="px-2 border text-center py-2 hover:bg-black hover:text-white cursor-pointer"
                          >
                            <div className="flex justify-center items-center">
                              <MdEditSquare size={20} />
                            </div>
                          </td>
                          <td
                            onClick={() => openDeleteModal(GroupName.id)}
                            className="px-2 border text-center py-2 hover:bg-black hover:text-white cursor-pointer"
                          >
                            <div className="flex justify-center items-center">
                              <FaTrash size={18} />
                            </div>
                          </td> */}
                          </tr>
                        )))}
                    </tbody>
                  </table>
                </div>
              </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AddGroup;